import { IconButton } from "@material-ui/core";
import { OpenInNewRounded } from "@material-ui/icons";
import React from "react";

export interface OpenUrlIconProps {
    url: string;
    tooltip?: string;
}

export function OpenUrlIcon({ url, tooltip = "Open in new tab" }: OpenUrlIconProps) {
    const handleClick = () => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <IconButton
            onClick={handleClick}
            title={tooltip}
            color="primary"
        >
            <OpenInNewRounded />
        </IconButton>
    );
};
